import { render, staticRenderFns } from "./TeamSocialMedia.vue?vue&type=template&id=7d488306&scoped=true&"
import script from "./TeamSocialMedia.vue?vue&type=script&lang=js&"
export * from "./TeamSocialMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d488306",
  null
  
)

export default component.exports